import api from '@/api'
import env from '@/env'
import utils from '@/utils'
import axios from 'axios'

export default {
  SEARCH_ADVERTISE: async ({ commit }) => {
    const response = await api.searchClientConfig()
    const userLang = utils.getLocaleBrowser();
    let userBannerLang = {
      visible: false,
      link: '',
      image: {
        src: '',
        alt: '',
      },
    };
    try {
      if(response.clientBannerList && response.clientBannerList.length > 0) {
        var bannerLanguage = response.clientBannerList.find(item => item.lang === userLang || item.lang === 'default');
        if(bannerLanguage) {
          userBannerLang.image.src = bannerLanguage.clientBannerUrl;
          userBannerLang.image.alt = bannerLanguage.clientBannerAlt;
          userBannerLang.link = bannerLanguage.clientBannerLink;
        }
      } else {
        const bannerUrl = env.getBannerUrl();
  
        const { data } = await api.getBannerJson(bannerUrl);
  
        if (!data) throw new Error("No banner registered")
  
        userBannerLang = data[userLang] || data['default']
      }
      if (!userBannerLang.image.src) throw new Error("No image registered")
      const status = await axios.get(userBannerLang.image.src).then((response) => response.status)
      if(status !== 200) throw new Error
      userBannerLang.visible = true
    } catch(error) {
      userBannerLang.visible = false
    } finally {
      commit('SET_ADVERTISE', userBannerLang)
    }
  },

  SEARCH_CLIENT_CONFIG: async ({ commit }) => {
    try {
      const response = await api.searchClientConfig()

      if (response.appName) {
        commit('SET_CLIENT_NAME', response.appName)
      }

      if (response.clientLogoBase64) {
        commit('SET_CLIENT_LOGO', response.clientLogoBase64)
      }
    } catch(error) {
      commit('SET_CLIENT_NAME', '')
      commit('SET_CLIENT_LOGO', '')
    }
  },

  AUTHENTICATE: ({ commit }, user) => {
    return Promise
      .all([
        api.authenticate(user),
      ])
      .then((result) => {
        commit('SET_AUTHENTICATION', true)
        return Promise.resolve(result)
      })
      .catch((error) => {
        commit('SET_AUTHENTICATION', false)
        return Promise.reject(new Error(error.message))
      })
  },

  START_LOADING: ({ commit }) => {
    commit('SET_LOADING', true)
  },

  STOP_LOADING: ({ commit }) => {
    commit('SET_LOADING', false)
  }
}
